import React from 'react';
import { FormGroup, Label } from 'reactstrap';
import { AvField } from 'availity-reactstrap-validation';
import i18n from '../../../i18next';

/**
 * MUST always be rendered in an AvForm !!
 */
const FieldsTemplate = props => {

    if (!props.fields || props.fields === '{}') return null;

    const { inputGroupStyle, labelStyle, inputStyle, fieldContainer } = styles;
    const { fields, update } = props;

    return (
        <div style={fieldContainer}>
            {
                Object.keys(fields).map(key => {

                    return (
                        <FormGroup key={key} style={inputGroupStyle}>
                            <Label style={labelStyle}>
                                {i18n.t(`screens:deliveryPartnerScreen.fields.${key}`)}
                            </Label>
                            <AvField style={inputStyle}
                                type={key === 'password' ? 'password' : 'text'}
                                name={key}
                                value={fields[key]}
                                onChange={update}
                                errorMessage={i18n.t('common:validations.errorMsg')}
                                required>
                            </AvField>
                        </FormGroup>
                    );
                })
            }
        </div>
    );
}

export default FieldsTemplate;

const styles = {
    inputGroupStyle: {
        width: '50%',
        padding: "10px 20px 0 20px",
        display: 'flex',
        marginBottom: 0
    },
    labelStyle: {
        padding: '10px 35px 0 0'
    },
    inputStyle: {
        // width: '60%'
    },
    fieldContainer: {
        display: 'flex',
        flexWrap: 'wrap'
    },
}


// WEBPACK FOOTER //
// ./src/components/common/stringTemplateRenderer/FieldsTemplate.js